/* eslint-disable max-len */
/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import utils, { TJoin, TNonEmptyArray, TTenant, TUser, TUserRole } from "../../helpers/utils.graphql";
import { CommandResult_User, CommandResult_Void } from "../../helpers/types.graphql";
import { CommandResult } from "../fragment.graphql";

export type TGlobal = TUser
  | TJoin<"tenant", TTenant>
  | TJoin<"userRoles", TUserRole>

type TUserCreateFunctions = { create: CommandResult_User };
export type TUserCreateMutations = { user: TUserCreateFunctions };
export const userCreate = () => gql`
  mutation userCreate($userCreateInput: UserCreateInput!) {
    user {
      create(userCreateInput: $userCreateInput) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_User")}
`;

type TUserUpdateFunctions = { update: CommandResult_User };
export type TUserUpdateMutations = { user: TUserUpdateFunctions };
export const userUpdate = (fields: TNonEmptyArray<TGlobal>) => gql`
  mutation userUpdate($user: UserUpdateInputType!) {
    user {
      update(user: $user) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_User")}
`;

type TUserDeleteFunctions = { delete: CommandResult_Void };
export type TUserDeleteMutations = { user: TUserDeleteFunctions };
export const userDelete = () => gql`
  mutation userDelete($id: Guid!, $permanent: Boolean) {
    user {
      delete(id: $id, permanent: $permanent) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;

type TUpdateUserTenantFunctions = { updateUserTenant: CommandResult_Void };
export type TUpdateUserTenantMutations = { user: TUpdateUserTenantFunctions };
export const updateUserTenant = () => gql`
  mutation updateUserTenant($idB2C: Guid!, $tenantId: Guid!) {
    user {
      updateUserTenant(idB2C: $idB2C, tenantId: $tenantId) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;